import {
  FunctionComponent,
} from 'react';
import { Route } from 'react-router-dom';

import { AdminRouteName } from '../CONSTANTS';
import AllLoans from './AllLoans';
import DeclinedLoans from './DeclinedLoans';
import DashboardWrap from '../../components/DashboardWrap';
import DisbursedLoans from './DisbursedLoan';
import AwaitingApprovalLoans from './AwaitingApprovalLoans';

import './loans.scss';

const AdminLoans: FunctionComponent = () => (
  <DashboardWrap>
    <div className="loans-root-cover">
      <Route component={AllLoans} path={AdminRouteName.loansRoute} exact />
      <Route component={DeclinedLoans} path={AdminRouteName.declinedLoansRoute} />
      <Route component={DisbursedLoans} path={AdminRouteName.disbursedLoansRoute} />
      <Route component={AwaitingApprovalLoans} path={AdminRouteName.awaitingApprovalLoansRoute} />
    </div>
  </DashboardWrap>
);

export default AdminLoans;
